import LegalLayout, { Section } from "@/components/chalky/LegalLayout"

interface Props {
  last_updated: string
}

const SUPPORT_EMAIL = "hello@chalky.fr"

export default function Privacy({ last_updated }: Props) {
  return (
    <LegalLayout
      title="Loon Remote"
      titleHighlight="Privacy Policy"
      subtitle="Loon Remote does not collect, store or share any personal data."
      lastUpdated={last_updated}
      lastUpdatedLabel="Last updated:"
      lang="en"
    >
      <Section number="1" title="No personal data">
        <p className="text-slate-400 leading-relaxed">
          Loon Remote does not collect, store or share any personal data. The app has no accounts, no analytics,
          no advertising and no crash reporting.
        </p>
      </Section>

      <Section number="2" title="Your console and your device">
        <p className="text-slate-400 leading-relaxed mb-4">
          The app talks only to your Behringer X32 console on your local network (OSC over UDP); your settings
          (console address, chosen mixes, layout) and your memories stay on your device.
        </p>
        <p className="text-slate-400 leading-relaxed">
          The app reads its own version number from the device to show it in Settings; nothing leaves the device.
        </p>
      </Section>

      <Section number="3" title="Links">
        <p className="text-slate-400 leading-relaxed">
          Links to this page and to support open in your device's browser, under that browser's own privacy terms.
        </p>
      </Section>

      <Section number="4" title="Contact">
        <p className="text-slate-400 leading-relaxed">
          Contact:{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-slate-200 hover:text-white underline">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </Section>
    </LegalLayout>
  )
}
